import customAxios from "../../customAxios";
import {COMPANY_REMOVE_DRIVER_FROM_SERVICE} from "../../routes";

async function serviceRemoveDriver(_id: string): Promise<any> {
  try {
    return (await customAxios.patch(`${COMPANY_REMOVE_DRIVER_FROM_SERVICE}/${_id}`, {})).data;
  } catch (error: unknown) {
    console.log({FIND_SERVICE: error});
  }
}

export default serviceRemoveDriver;
